<!-- Source列表展示 -->
<template>
  <div class="LeftSourceList">
    <div class="contentleftBottom">
      <div class="FileSourceTop">
        <!-- 头部操作 -->
        <div class="searchTitle">
          <i
            class="iconfont icon-search pointer"
            @click="goToLogin('welcomeLiveSourceSearch')"
            :title="$t('lang.search')"></i>
          <i
            class="iconfont icon-Filter pointer"
            @click.stop="filterShow"
            :title="$t('lang.filters')"></i>
        </div>
        <!-- 搜索 -->
        <div
          class="searchInput"
          v-if="sourceInput">
          <el-input
            v-model="sourceCondition"
            :placeholder="$t('lang.searchTText')"
            class="SearchInput"
            @change="searchChange"></el-input>
          <i
            class="iconfont icon-search pointer"
            @click="searchChange"></i>
        </div>
      </div>
      <div
        class="SourceListWrap"
        v-scroll="bindSourceScroll">
        <ul class="draggable_box sourceItem">
          <li
            :class="['draggable_item',{ 'pitchOnItem': PitchSource == item.id}]"
            v-for="(item, index) in sourceData"
            @click="getCheck(item)"
            :key="item.id"
            :data-device="JSON.stringify(item)"
            draggable="true"
            :data-target="'source' + index"
            :title="item.name">
            <div class="antlineWrap">
              <img
                :src="require('@/assets/img/logo_thumbnail.png')"
                :onerror="errorImg" />
              <span
                class="ellipsis"
                style="max-width: 90%"
                :title="item.name">{{ item.name }}</span>
            </div>
          </li>
        </ul>
      </div>
      <!-- <div class="hrefCc">
        <a @click="hrefCc">Multiviewer ></a>
      </div> -->
    </div>
  </div>
</template>

<script>
// import Cascader from '@/components/common/Cascader'
import Bus from '@/assets/js/vueBus.js'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { SHOWDEVICEIMG } from '@/assets/js/filters'
import { setInterval, clearInterval } from 'timers'
import toTips from '@/assets/js/toTipsObj'
import { creatAccount } from '@/assets/js/common/creatAccount.js'
import { playoutAnalyze } from '@/assets/js/googleAnalyze/playout.js'
export default {
  props: {
    FilterBookmark: {
      type: Array,
      default: () => []
    }
  },
  components: {
    // Cascader
  },
  data () {
    return {
      // 选中source
      PitchSource: '',
      // source数据
      sourceData: [],
      sourcePar: {
        // 获取源列表的参数
        condition: '',
        bookmardIds: 'all',
        unClassified: true,
        pack: true,
        anywhere: true,
        gridPack: true,
        gridSdi: true,
        ext: true,
        token: true,
        pageNum: 1,
        pageSize: 35
      },
      // source绑定滚动事件
      bindSourceScroll: {
        onScroll: this.bindSourceScrollHandle,
        distance: 10,
        directive: '.sourceItem'
      },
      SourceSwitch: {
        bookmark: true,
        filterBox: false
      },
      // 搜索开关
      sourceInput: false,
      // 搜索的内容
      sourceCondition: '',
      isIndeterminate: false,
      // 选项
      filterOptions: [
        'lang.tvuPack',
        'lang.tvuAnywhere',
        'lang.gridPack',
        'lang.gridSDI',
        'Ext',
        'token'
      ],
      // 选中状态
      checkedFilterList: [
        'lang.tvuPack',
        'lang.tvuAnywhere',
        'lang.gridPack',
        'lang.gridSDI',
        'Ext',
        'token'
      ],
      selBookmarkLength: this.FilterBookmark.length,
      // 选中全部
      checkAll: true,
      errorImg: `this.src="${require('@/assets/img/logo_thumbnail.png')}"`,
      // 可是范围内的source列表
      ScopeSourceList: [],
      ScopeSourceListId: [],
      // 上一次图片缩略图
      LastImagePerview: {},
      // 当前图片缩略图
      CurrentImagePerview: {},
      // 当前图片缩略图
      SourceThumbnail: {},
      Interval: null
    }
  },
  created () {
    // this.$nextTick(() => {
    //   this.selBookmarkLength = this.FilterBookmark.length
    //   this.getSourceList()
    // })
    this.getSourceList()
  },
  mounted () {
  },
  computed: {
    ...mapState({
      pageRequest: (state) => state.websocket.pageRequest
    })
  },
  methods: {
    goToLogin (tag) {
      creatAccount()
      playoutAnalyze(tag)
    },
    // 搜索显示
    searchShow () {
      this.sourceInput = !this.sourceInput
      this.SourceSwitch.filterBox = false
      this.reGetSourceList()
    },
    // 过滤显示
    filterShow () {
      this.SourceSwitch.filterBox = !this.SourceSwitch.filterBox
      this.sourceInput = false
    },
    prevent (e) {
      e.stopPropagation()
    },
    // bookmark，filter开关
    switchShowBF () {
      this.SourceSwitch.bookmark = !this.SourceSwitch.bookmark
    },
    // source查询条件
    initSourcePar (val) {
      this.sourcePar.pack = val
      this.sourcePar.anywhere = val
      this.sourcePar.gridPack = val
      this.sourcePar.gridSdi = val
      this.sourcePar.ext = val
      this.sourcePar.token = val
    },
    // 清空搜索条件重新查询
    reGetSourceList () {
      this.sourcePar.condition = ''
      this.sourcePar.pageNum = 1
      this.sourcePar.pageSize = 35
      this.getSourceList()
    },
    // 点击source发生事情
    getCheck (data) {
      if (this.PitchSource == data.id) {
        this.PitchSource = ''
      } else {
        this.PitchSource = data.id
      }
      if (data.url) {
        this.$emit('SetPreviewVideo', data, 'Media')
      }
      playoutAnalyze('welcomeLiveSourceSelectedSource')
    },
    // 缩略图
    thumblImg (x) {
      if (x.status == 2 && this.CurrentImagePerview[x.peerId] != undefined && this.CurrentImagePerview[x.peerId] == this.LastImagePerview[x.peerId]) return
      if (this.CurrentImagePerview[x.peerId] != undefined && this.CurrentImagePerview[x.peerId] == this.LastImagePerview[x.peerId] && x.status == 1) return
      this.LastImagePerview[x.peerId] = this.CurrentImagePerview[x.peerId]
      this.SourceThumbnail[x.peerId] = SHOWDEVICEIMG(x)
    },
    // 获取source列表
    getSourceList (load) {
      this.sourceData = [{
        directory: true,
        id: 'b8033031e72b44e189e6b81805e50a7d',
        name: 'Grid_Channel',
        type: 'live',
        url: 'https://pp-va-001.s3.amazonaws.com/d8c2d18d71024ba289dec41529ae5247/Promo/TVU%20Promo%20Compilation%2060%20Minutes%2010-28-21.mp4',
        videoTimes: '1329.462',
        videoUrls: 'https://pp-va-001.s3.amazonaws.com/d8c2d18d71024ba289dec41529ae5247/Promo/TVU%20Promo%20Compilation%2060%20Minutes%2010-28-21.mp4',
        visible: true
      }]
      this.$nextTick(() => {
        Bus.$emit('leftListUpdate')
      })
    },
    // 滚动加载
    bindSourceScrollHandle () {
      if (this.sourceHasnextpage) {
        this.sourcePar.pageNum = this.sourcePar.pageNum + 1
        this.getSourceList(true)
      }
    },
    // 搜索
    searchChange () {
      this.sourcePar.condition = this.sourceCondition
      this.sourcePar.pageNum = 1
      this.sourcePar.pageSize = 35
      this.getSourceList()
    }
  },
  beforeDestroy () {
    if (this.Interval) {
      clearInterval(this.Interval)
    }
    // if (this.$createWebsocket.pageRequest) {
    //   this.$createWebsocket.pageRequest('stop', ['taskInfo_T_S']) // 停止websocket
    // }
  }
}
</script>

<style scoped lang="less">
.LeftSourceList {
  .contentleftBottom {
    width: 100%;
    position: relative;
    .FileSourceTop {
      .searchTitle {
        padding: 12px 0 10px 0;
        border-bottom: 2px solid #555;
        text-align: right;
        i {
          margin: 0 4px;
          color: #cccccc;
        }
      }
      .searchInput {
        position: relative;
        i {
          position: absolute;
          right: 12px;
          font-size: 20px;
          top: 7px;
          z-index: 1001;
        }
      }
    }
    .SourceListWrap {
      .sourceItem {
        height: 470px;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        padding-top: 8px;
        .antlineWrap {
          width: 100px;
          margin: 8px 4px;
          img {
            width: 100px;
            height: 63px;
            margin-top: 3px;
            object-fit: cover;
            display: block;
          }
          span {
            display: block;
            width: 100px;
            height: 20px;
            text-align: left;
            overflow: hidden;
            line-height: 20px;
            font-size: 12px;
            color: #dfdfdf;
          }
        }
        .pitchOnItem {
          background: rgba(57, 170, 80, 0.25);
          // position: relative;
          // background-color: #3f5d46 !important;
          // background-image: -webkit-linear-gradient(
          //   -45deg,
          //   rgba(16, 180, 103, 1) 25%,
          //   rgba(16, 180, 103, 0) 25%,
          //   rgba(16, 180, 103, 0) 50%,
          //   rgba(16, 180, 103, 1) 50%,
          //   rgba(16, 180, 103, 1) 75%,
          //   rgba(16, 180, 103, 0) 75%,
          //   rgba(16, 180, 103, 0)
          // );
          // background-size: 10px 10px;
          // animation: antline 0.8s linear infinite;
          // .antlineWrap {
          //   width: 100%;
          //   height: 85px;
          //   background-color: #3f5d46;
          // }
        }

        // .pitchOnItem::after {
        //   position: absolute;
        //   top: 2px;
        //   left: 2px;
        //   bottom: 2px;
        //   right: 2px;
        //   display: block;
        //   content: '';
        //   background-color: transparent;
        // }
      }
    }

    .hrefCc {
      height: 30px;
      a {
        height: 100%;
        line-height: 40px;
        float: left;
        color: #33ab4f;
        cursor: pointer;
        font-size: 14px;
        padding-left: 21px;
      }
    }
  }
  .bookmarkSearch {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;

    .filter_box {
      height: calc(100% - 50px);
      background: #aaa;
      padding: 10px 0;
      z-index: 10;

      /deep/ .el-checkbox .el-checkbox__inner {
        background: #fff;
      }

      .filter_item {
        margin: 0 auto;
        width: 90%;
        height: unset;
        background: #444;
        border-radius: 5px;

        .item_title {
          border-radius: 5px;
          height: 45px;
          line-height: 45px;
          padding-left: 10px;
          background: #616161;
          color: #aaa;
          font-size: 14px;
        }

        .item_title.active {
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          // .el-icon-caret-bottom {
          //     transform: rotate(-180deg);
          // }
        }

        // .pull_down {
        //     position: absolute;
        //     right: 15px;
        //     top: 50%;
        //     transform: translateY(-50%);
        // }
        .el-icon-caret-bottom {
          color: #fff;
          font-size: 22px;
          line-height: 45px;
          margin-right: 15px;
          transition: 0.3s;
        }
      }

      .item_content {
        margin: 0 auto;
        width: 90%;
        height: 241px;
        line-height: 30px;
        background-color: #444;
        // margin-bottom: 10px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        font-size: 12px;
      }

      /deep/ .el-checkbox {
        margin: 0;
        display: block;
        overflow: hidden;
        text-align: left;
        padding: 0 8px;
      }
      /deep/ .el-checkbox__inner:after {
        border-color: #33ab4f;
        left: 6px;
        top: 2px;
      }
    }
  }
}
</style>
